import { useContext, useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";

import "./App.css";
import NotificationsContext from "./context/notifications";

import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";

import Home from "./pages/home/Home";

import Art from "./pages/art/Art";
import AnimalCrossing from "./pages/video_games/AnimalCrossing";
import Photography from "./pages/photography/Photography";
import SoftwareEngineering from "./pages/software_engineering/SoftwareEngineering";
// import U from "./pages/chatbot/Chatbot";
import WoodBurning from "./pages/wood_burning/WoodBurning";
import PrivacyPolicy from "./pages/privacy_policy/PrivacyPolicy";

import Cookbook from "./pages/cookbook/Cookbook";
import Pancakes from "./pages/cookbook/recipes/Pancakes";
import Popcorn from "./pages/cookbook/recipes/Popcorn";
import BananaBread from "./pages/cookbook/recipes/BananaBread";

import Oregon from "./pages/oregon/Oregon";
import Emma from "./pages/emma/Emma";
import Queues from "./pages/software_engineering/queues/Queues";

function App() {
  const { array } = useContext(NotificationsContext);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="page">
      {array}
      <Header />

      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/wood-burning" element={<WoodBurning />} />
        <Route path="/software-engineering" element={<SoftwareEngineering />} />
        {/* <Route path="/software-engineering/u" element={<U />} /> */}
        <Route path="/software-engineering/queues" element={<Queues />} />
        <Route path="/cookbook" element={<Cookbook />} />
        <Route path="/cookbook/banana-bread" element={<BananaBread />} />
        <Route path="/cookbook/pancakes" element={<Pancakes />} />
        <Route path="/cookbook/popcorn" element={<Popcorn />} />
        <Route path="/animal-crossing" element={<AnimalCrossing />} />
        <Route path="/art" element={<Art />} />
        <Route path="/best-day-ever" element={<Emma />} />
        <Route path="/emma" element={<Emma />} />
        <Route path="/oregon" element={<Oregon />} />
        <Route path="/photography" element={<Photography />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/*" element={<Navigate replace to="/" />} />;
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
